module.exports = __webpack_public_path__ + "Calming-1bc28b79163f64e5fd2042563aeee43e.svg";